import type { Coordinate } from './map.cluster';
import type { MapBounds } from './map.interface';

interface BoundsView {
	bounds: MapBounds;
}

interface CenterView {
	center: Coordinate;
	zoom: number;
}

export type MapView = BoundsView | CenterView;

export function boundsOf(positions: Coordinate[]): MapBounds {
	const longs = positions.map(([long]) => long);
	const lats = positions.map(([, lat]) => lat);

	return [
		Math.min(...longs),
		Math.min(...lats),
		Math.max(...longs),
		Math.max(...lats),
	];
}

export function isBoundsView(view: MapView): view is BoundsView {
	return 'bounds' in view;
}
